interface GetPlannerViewStateParams {
  rowCount: number;
  assignmentGroupCount: number;
  filters: Record<string, string | string[]>;
  isLoading: boolean;
  error?: Error | null;
}

interface PlannerViewState {
  showInitialLoader: boolean;
  showErrorState: boolean;
  showEmptyState: boolean;
  showNoDataState: boolean;
  showPlannerEmptyState: boolean;
}

export const getPlannerViewState = ({
  rowCount,
  assignmentGroupCount,
  filters,
  isLoading,
  error,
}: GetPlannerViewStateParams): PlannerViewState => {
  const showInitialLoader = isLoading && rowCount === 0 && assignmentGroupCount === 0;
  const showErrorState = Boolean(error) && !isLoading;
  const hasFiltersApplied = Object.keys(filters).length > 0;
  const showEmptyState = rowCount === 0 && !isLoading && !showErrorState;

  return {
    showInitialLoader,
    showErrorState,
    showEmptyState,
    showNoDataState: showEmptyState && hasFiltersApplied,
    showPlannerEmptyState: showEmptyState && !hasFiltersApplied,
  };
};
